export const stepLabels = [
  "Select Team",
  "Application Information",
  "Infrastructure Configuration",
  "Review and Submit",
];
